import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore, hasAnyRole } from './store';
import type { ReactNode } from 'react';

export function RequireAuth({ roles, children }: { roles?: string[]; children: ReactNode }) {
  const { accessToken, user } = useAuthStore();
  const loc = useLocation();
  if (!accessToken || !user) return <Navigate to="/login" state={{ from: loc }} replace />;
  if (roles && roles.length > 0 && !hasAnyRole(user, ...roles))
    return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
}
